module.exports = __webpack_public_path__ + "bd0e0e713f26773192670effdd204e68.svg";